const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const CopyTable = require("../../office/data/CopyTable");
const DropdownSelect = require("../../core/view/DropdownSelect");
const StepWrapper = require("./StepWrapper");

const styles = require("./styles/SetSettings.css");

module.exports = createReactClass({
	displayName: "SetBaLevel",

	propTypes: {
		studentData: PT.object.isRequired,
		copy: PT.object.isRequired,
		renderButton: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		onChange: PT.func.isRequired,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
		handleBack: PT.func,
	},

	getInitialState: function() {
		return {
			age: null,
			baLevel: null,
		};
	},

	chooseAge: function(newAge) {
		if (newAge && newAge !== this.state.age) {
			let newBaLevel = 1;
			if (newAge === "under6") {
				newBaLevel = 1;
			} else if (newAge === "6") {
				newBaLevel = 1;
			} else if (newAge === "7") {
				newBaLevel = 1;
			} else if (newAge === "8") {
				newBaLevel = 2;
			} else if (newAge === "9") {
				newBaLevel = 3;
			} else if (newAge === "10") {
				newBaLevel = 4;
			} else if (newAge === "11" || newAge === "over11") {
				newBaLevel = 5;
			}
			this.setState({age: newAge, baLevel: newBaLevel});
		}
	},

	chooseGrade: function(newBaLevel) {
		this.setState({baLevel: parseInt(newBaLevel)});
		this.props.onChange();
	},

	handleSubmit: function() {
		this.props.handleSubmit(this.state.baLevel);
	},

	render: function() {
		const {age, baLevel} = this.state;
		const wrapperProps = _.pick(this.props, [
			"copy",
			"renderButton",
			"renderError",
			"stepNumber",
			"totalNumSteps",
			"handleBack",
		]);

		const gradeInfo = CopyTable.getAccountOptions({type: "grade", styles});
		const gradeOptions = _.zipObject(
			_.map(gradeInfo.options, "key"),
			_.map(gradeInfo.options, "label")
		);
		const ageInfo = CopyTable.getAccountOptions({type: "age"});
		const ageOptions = _.zipObject(
			_.map(ageInfo, "key"),
			_.map(ageInfo, "label")
		);

		const baLevelDropdown =
			baLevel || age ? (
				<DropdownSelect
					className={styles.dropdown}
					initialValue={this.state.baLevel.toString()}
					defaultOption={"Select a level"}
					options={gradeOptions}
					updateSelection={this.chooseGrade}
					optionHeight={36}
					tabIndex={1}
				/>
			) : (
				this.props.copy.baLevelDropdownPlaceholderText
			);

		let levelAdditionalInfo;
		if (age) {
			const ageOption = _.find(ageInfo, o => o.key === age);
			const ageBaLevelMismatch =
				baLevel && ageOption.recommendedLevel < baLevel;
			const autoFillTextClass = ageBaLevelMismatch
				? styles.autoFillTextMismatch
				: styles.autoFillText;
			const mismatchText = ageBaLevelMismatch
				? `Consider BA ${ageOption.recommendedLevel} to set your student up for early
				success before moving to BA ${baLevel}.`
				: null;
			levelAdditionalInfo = (
				<div className={autoFillTextClass}>
					{ageOption.description}
					{ageBaLevelMismatch ? <br /> : null}
					{mismatchText}
				</div>
			);
		}

		return (
			<StepWrapper {...wrapperProps} handleSubmit={this.handleSubmit}>
				{this.props.copy.text}
				<div className={styles.container}>
					<div className={styles.baLevelLabel}>{"Age:"}</div>
					<DropdownSelect
						className={styles.dropdown}
						initialValue={this.state.age}
						defaultOption={"Select"}
						options={ageOptions}
						customSortedOptionKeys={[
							"under6",
							"6",
							"7",
							"8",
							"9",
							"10",
							"11",
							"over11",
						]}
						updateSelection={this.chooseAge}
						optionHeight={36}
						tabIndex={0}
					/>
				</div>
				<div className={styles.container}>
					<div className={styles.baLevelLabel}>{"Level:"}</div>
					{baLevelDropdown}
				</div>
				{levelAdditionalInfo}
			</StepWrapper>
		);
	},
});
